import { LowPriceTabItem, MidYearSectionConfig } from "@/shared";
import {
  LowPriceTabKey,
  MidYearPromotionCategory,
  MidYearSectionDisplayType,
  searchV3Type,
  TrackingZoneName,
} from "../enums";

/** 年中大促Tab配置数组（按顺序） */
export const MIDYEARSALE_TAB_LIST: MidYearSectionConfig[] = [
  {
    id: "incentiveOffer",
    name: "Incentive Offer",
    apiParam: "incentive",
    description: "Share a $600,000 Cash Prize Pool!",
    category: MidYearPromotionCategory.IncentiveOffer,
    type: MidYearSectionDisplayType.Product,
  },
  {
    id: "textSwiper",
    name: "Text Swiper",
    apiParam: "",
    description: "",
    type: MidYearSectionDisplayType.TextSwiper,
    textSwiperData: [
      ["YooFinds benefits for influencers:", "1 million Ad spend"],
      ["Use a Hashtag to Get More Traffic!", "#dealsforyoudays"],
    ],
  },
  {
    id: "superCommission",
    name: "Super Commission",
    apiParam: "supercommission",
    description: "View More",
    category: MidYearPromotionCategory.SuperCommission,
    type: MidYearSectionDisplayType.Product,
  },
  {
    id: "flashSale",
    name: "Flash Sale",
    apiParam: "flashsale",
    description: "View More",
    category: MidYearPromotionCategory.FlashSale,
    type: MidYearSectionDisplayType.Product,
    contentText: [
      "Request Now & Post Product Video",
      "Sell Out Fast When Flash Sale Begins!",
    ],
  },
  {
    id: "discountSection",
    name: "Discount Section",
    apiParam: "discountsection",
    description: "View More",
    category: MidYearPromotionCategory.DiscountSection,
    type: MidYearSectionDisplayType.Product,
    contentText: [
      "Emphasize the discount in your",
      "video to drive more orders!",
    ],
  },

  {
    id: "keyLivestream",
    name: "Summer Sale",
    apiParam: "keylivestream",
    description: "View More",
    category: MidYearPromotionCategory.KeyLivestream,
    type: MidYearSectionDisplayType.Product,
  },
];
const allKey =
  searchV3Type.Beauty +
  "," +
  searchV3Type.Women +
  "," +
  searchV3Type.Home +
  "," +
  searchV3Type.Appliance;

/** 年中大促更多Tab配置 */
export const MIDYEARSALE_MORE_TAB_LIST: { key: string; title: string }[] = [
  { key: allKey, title: "All" },
  { key: searchV3Type.Beauty, title: "Beauty & Personal Care" },
  { key: searchV3Type.Women, title: "Womensweat" },
  { key: searchV3Type.Home, title: "Home Supplies" },
  { key: searchV3Type.Appliance, title: "Phones&Electronics" },
];

/** 年中大促商品类别到追踪区域名称的映射*/
export const MidYearCategoryZoneMapper: Record<
  MidYearPromotionCategory,
  TrackingZoneName
> = {
  [MidYearPromotionCategory.IncentiveOffer]: TrackingZoneName.Incentive,
  [MidYearPromotionCategory.SuperCommission]: TrackingZoneName.SuperCommission,
  [MidYearPromotionCategory.FlashSale]: TrackingZoneName.FlashSale,
  [MidYearPromotionCategory.DiscountSection]: TrackingZoneName.DiscountSection,
  [MidYearPromotionCategory.KeyLivestream]: TrackingZoneName.KeyLiveStream,
  [MidYearPromotionCategory.Category]: TrackingZoneName.Category,
};

export const LOW_PRICE_TAB_LIST: LowPriceTabItem[] = [
  { key: LowPriceTabKey.Day28SalesCount, label: "28d Sold" },
  { key: LowPriceTabKey.CreatorCommissionRate, label: "Commission Rate" },
];

export const BF2025AiTop3BonusList = [
  {
    rank: 2,
    reward: "2,000",
  },
  {
    rank: 1,
    reward: "3,000",
  },
  {
    rank: 3,
    reward: "1,000",
  },
];

export const BF2025AiOtherBonusList = [
  {
    rank: "#4 - #10",
    reward: "500",
  },
  {
    rank: "#11 - #20",
    reward: "200",
  },

  {
    rank: "#21 - #30",
    reward: "100",
  },
];

export const ZoneNameToActivityTypeMap: Record<string, string> = {
  [TrackingZoneName.Lovers2026DateNightGlam]: "date-night-glam",
  [TrackingZoneName.Lovers2026DailylifeRomance]: "dailylife-romance",
  [TrackingZoneName.Lovers2026HeartfeltGiftGuide]: "heartfelt-gift",
};
